






























import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { Button } from '@bambora/payment-ui-components'
import { Api } from '@/service/Service'
import JavascriptAPI from '@/utils/JavascriptAPI'
import InitLoader from '@/components/Misc/InitLoader.vue'
import { ContextState, User, Config, DidInitAuth, Settings } from '@/store/context/contextTypes'
import { createDidCodeVerification } from '@/utils/didHelpers'
import { providerLogo, deviceIdExists } from '@/utils/helpers'

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  props: {
    provider: { type: Object, required: true },
    redirectContent: { type: Object, required: true }
  },
  computed: {
    ...mapState({
      config: (state: any): object => state.context.config,
      isMobile: (state: any): object => state.context.isMobile,
      didInitialAuth: (state: any): object => state.context.didInitialAuth,
      rememberDevice: (state: any): object => state.context.settings.rememberDevice
    })
  },
  components: {
    Button,
    InitLoader
  },
  watch: {
    rememberDevice (rememberDevice: boolean, previousRememberDevice: boolean) {
      if (rememberDevice !== previousRememberDevice && this.didInitialAuth && this.didInitialAuth.didCodeChallenge && this.showProvider) {
        // this decided if we apped or not apped deviceId to the url if the inital auth did-iframe. When this is switched, we sadly have to reload the frame
        this.setupAuthIframe(this.didInitialAuth)
      }
    },
    didInitialAuth (currentAuth: DidInitAuth | null, previousAuth: DidInitAuth | null) {
      if (currentAuth.didCodeVerifier && currentAuth.didCodeChallenge) {
        this.setupAuthIframe(currentAuth)
      }
    },
    // have to react to provider change and make a new sequence of requests to DID
    async redirectContent (currentContent: any | null, previousContent: any | null) {
      if (currentContent.id !== previousContent.id) {
        this.setAutoShowProvider()
        if (!this.showProvider) {
          await createDidCodeVerification()
        } else {
          this.iframeLoaded = false
        }
      }
    }
  }
})
export default class IdentityRedirectContent extends Vue {
  config: Config
  rememberDevice: boolean
  isMobile: boolean
  showProvider: boolean = true
  iframeLoaded: boolean = false
  $refs!: {
    redirectContentIframe: HTMLIFrameElement
  }
  @State('context') context: ContextState
  @Action('setIsLoading', { namespace: _CONTEXT_ }) setIsLoading: any
  @Action('setIdentifyWizardStep', { namespace: _CONTEXT_ }) setIdentifyWizardStep: any
  @Action('lookupAuthenticatedUser', { namespace: _CONTEXT_ }) lookupAuthenticatedUser: any
  @Action('setDidCodeVerifierChallenge', { namespace: _CONTEXT_ }) setDidCodeVerifierChallenge: any
  @Action('setIdentifyProviderId', { namespace: _CONTEXT_ }) setIdentifyProviderId: any
  @Action('setEditUser', { namespace: _CONTEXT_ }) setEditUser: any

  beforeMount () {
    // Some providers we don't want to auto-initiate. BankId-SE for example autotriggers bankId to load
    // on mobiles which causes the user to get a "Open bankId?" dialog when the checkout loads.
    // We want this behavour to be user-initiated
    this.setAutoShowProvider()
  }

  mounted () {
    // On mobile, bankId is triggered right away, causing the user to get a dialog to open bankId onload
    // We want this to be user initiated. On desktop things can load right away.
    if (this.$props.redirectContent.url && this.showProvider) {
      this.initiateProvider()
    }
  }

  get getProviderLogo () {
    return providerLogo(this.$props.provider.id)
  }

  get getIframeUrl () {
    return this.$props.redirectContent.url
  }

  setupAuthIframe (currentAuth) {
    let url = this.$props.redirectContent.url
    url += `&code_challenge_method=S256&code_challenge=${currentAuth.didCodeChallenge}`

    const deviceId = localStorage.getItem('piq_dId')
    if (deviceIdExists() && this.rememberDevice) {
      url += `&device_id=${deviceId}`
    }

    const iframe = this.$refs['redirectContentIframe']
    iframe.src = url
  }

  setAutoShowProvider () {
    const { autoShow } = this.$props.redirectContent
    if (autoShow.hasOwnProperty('mobile') && this.isMobile) {
      this.showProvider = autoShow.mobile
    } else {
      this.showProvider = autoShow.default
    }
  }

  async initiateProvider () {
    this.showProvider = true
    await this.$nextTick()
    await this.$nextTick()
    setTimeout(async () => {
      // We risk calling this before the eventListener has registered in the Integration-script. This needs to be resolved in a better way.
      await createDidCodeVerification()
    }, 500)
  }

  routeToManual () {
    this.setIdentifyProviderId('manual')
    this.setEditUser(true)
  }

  manualInitProvider () {
    this.showProvider = true
    this.initiateProvider()
  }

  providerLoaded () {
    if (this.$refs.redirectContentIframe && this.$props.redirectContent.containerHeight) {
      this.$refs.redirectContentIframe.style.height = this.$props.redirectContent.containerHeight + 'px'
    }
    setTimeout(() => {
      this.iframeLoaded = true
    }, 1000)
    setTimeout(() => {
      JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
    }, 200)
  }

  writeIframeContent (content) {
    if (this.$refs['redirectContentIframe'] && content) {
      const doc = this.$refs['redirectContentIframe'].contentWindow.document
      doc.open()
      doc.write(content)
      doc.close()
    }
  }
}
